import searchParams from './searchParams'

const isAuthorized = searchParams['IS_AUTHORIZED'] === 'Y'

export default isAuthorized
